import React, { useMemo } from "react"
import { FlashList, FlashListProps } from "@shopify/flash-list"
import { SectionListProps } from "react-native"
// import { SectionList } from "react-native"

const SectionList = (props: SectionListProps<any> & Omit<FlashListProps<any>, "renderItem"|"data">) => {
  const { renderItem, renderSectionHeader, sections: sectionsProps, ...restProps } = props;

  const sections = useMemo(() => {
    const data = [];
    sectionsProps.forEach((s) => {
      data.push({ title: s.title });
      s.data.forEach((d) => {
        data.push(d)
      })
    })
    return data
  }, [sectionsProps])

  return (
    <FlashList
      data={sections}
      renderItem={(info) => {
        if (info.item.title) {
          // Rendering header
          return renderSectionHeader({ section: info.item });
        } else {
          // Render item
          return renderItem(info as any);
        }
      }}
      getItemType={(item) => {
        // To achieve better performance, specify the type based on the item
        return item.title ? "sectionHeader" : "row";
      }}
      {...restProps}
    />
  );
};

export { SectionList };
